import OrderDataContent from './OrderDataContent';

export default OrderDataContent;
